<script>
    export let label;
    export let classes = "btn btn-primary small";
</script>

<button class="{classes}" on:click>{label}</button>

<style>
</style>